import React, { useState, useEffect } from 'react';

const Investigacao = () => {
	return <div className='text-3xl '> Investigacao DE DENGUE</div>;
};

export default Investigacao;
